import { render, staticRenderFns } from "./ActionHandlePortingCancellationManually.vue?vue&type=template&id=3a19e4bd&scoped=true&"
import script from "./ActionHandlePortingCancellationManually.vue?vue&type=script&lang=js&"
export * from "./ActionHandlePortingCancellationManually.vue?vue&type=script&lang=js&"
import style0 from "./ActionHandlePortingCancellationManually.vue?vue&type=style&index=0&id=3a19e4bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19e4bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
